import { AppSettings } from '../settings/index';

export class Constant {
    public static readonly defaultOrderType = 'NM';
    public static readonly defaultServiceType = 'SO';
    public static readonly defaultAsnServiceType = 'ASN';
    public static readonly defaultReportFormat = 'PDF';
	public static readonly defaultModuleId = "OP";

    public static TransactionCode = class {
        public static const selfCollection = 'SC';      // = 'SC';
        public static const transportationByMandaiLink = 'OUT';
    };

    public static OnlineOrderStatus = class {
        public static const new = '1';
        public static const released = '2';
        public static const cancelled = 'C';
        public static const deleted = 'X';
    };

    public static OnlineShippingNoticeStatus = class {
        public static const draft = 'D';
        public static const new = '1';
        public static const released = '2';
        public static const error = 'E';
    };

    public static MessageType = class {
        public static const success = 'INFORMATION';
        public static const confirmation = 'CONFIRMATION';
        public static const error = 'ERROR';
    };

    public static MessageIcon = class {
        public static const success = 'fa fa-check-circle';
        public static const confirmation = 'fa fa-question-circle';
        public static const error = 'fa fa-times-circle';
    };

    public static MessageNumber = class {
        public static const defaultError = '11';
    };

    public static Message = class {
        public static const defaultError = 'Failed to process your request';
    };

    // public static DeliveryType = class {
    //     public static const selfCollection = 'SelfCollection';
    //     public static const transportationByMandaiLink = 'TransportationByMandailink';
    // }

    public static VehicleType = class {
        public static const container = 'Container';
        public static const truck = 'Truck';
    };

    public static BookingType = class {
        public static const incoming = 'Incoming';
        public static const outgoing = 'Outgoing';
    };

    public static TicketStatusCode = class {
        public static const all = '';
        public static const new = '1';
        public static const reserved = '2';
        public static const loading = '3';
        public static const unstuffing = '4';
        public static const finished = '5';
        public static const truckOut = '6';
        public static const cancel = 'C';
    };
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/common/constant.ts